(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["navika-language-dropdown"] && !Shopify.designMode) return;
  try {
    if(!window.navikaLanguageBound){
 window.navikaLanguageBound=true;
 const preferenceKey='navika_language_preference';
 document.addEventListener('click',event=>{
  const languageButton=event.target.closest('.nv-language-dropdown button[name="language_code"]');
  if(languageButton){try{localStorage.setItem(preferenceKey,languageButton.value)}catch(_){}}
  document.querySelectorAll('.nv-language-dropdown[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false});
 });
 document.addEventListener('keydown',event=>{
  if(event.key!=='Escape')return;
  const menu=document.activeElement.closest('.nv-language-dropdown[open]');
  if(menu){menu.open=false;menu.querySelector('summary').focus()}
 });
 try{
  const stored=localStorage.getItem(preferenceKey);
  const current=(document.documentElement.lang||'').toLowerCase();
  if(!stored&&current.startsWith('es')&&!window.Shopify?.designMode){
   const english=document.querySelector('.nv-language-dropdown button[name="language_code"][value="en"]');
   if(english){
    localStorage.setItem(preferenceKey,'en');
    requestAnimationFrame(()=>english.click());
   }
  }
 }catch(_){}
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["navika-measurement"] && !Shopify.designMode) return;
  try {
    if (!window.navikaMeasurementBound) {
 window.navikaMeasurementBound = true;
 const consentReady = new Promise(resolve => {
  if (window.Shopify?.customerPrivacy) return resolve(window.Shopify.customerPrivacy);
  if (!window.Shopify?.loadFeatures) return resolve(null);
  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => resolve(error ? null : window.Shopify.customerPrivacy));
 });
 document.addEventListener('submit', event => {
  const form = event.target;
  if (!form.matches('.navika-signup__form, .email-signup__form, #NavikaJournalSignup, #NavikaPrelaunchSignup') || !form.checkValidity()) return;
  if (window.Shopify?.customerPrivacy?.currentVisitorConsent().analytics !== 'yes' || !window.Shopify.customerPrivacy.analyticsProcessingAllowed()) return;
  try { sessionStorage.setItem('navika_signup_pending', String(Date.now())); } catch (_) {}
 });
 consentReady.then(privacy => {
  if (privacy?.currentVisitorConsent().analytics !== 'yes' || !privacy.analyticsProcessingAllowed() || !document.querySelector('[data-nv-signup-success]')) return;
  try {
   const pending = Number(sessionStorage.getItem('navika_signup_pending'));
   sessionStorage.removeItem('navika_signup_pending');
   if (!pending || Date.now() - pending > 1800000) return;
   if (window.Shopify?.analytics?.publish) {
    Promise.resolve(window.Shopify.analytics.publish('navika:email_signup', { form: 'newsletter', status: 'accepted' })).catch(() => {});
   }
  } catch (_) {}
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["navika-navigation"] && !Shopify.designMode) return;
  try {
    if(!window.navikaHamburgerBound){
 window.navikaHamburgerBound=true;
 document.addEventListener('click',event=>{
  document.querySelectorAll('.nv-hamburger[open]').forEach(menu=>{
   if(!menu.contains(event.target)||event.target.closest('a'))menu.open=false;
  });
 });
 document.addEventListener('keydown',event=>{
  if(event.key!=='Escape')return;
  const menu=document.activeElement.closest('.nv-hamburger[open]');
  if(menu){menu.open=false;menu.querySelector('summary').focus()}
 });
}
  } catch(e) { console.error(e); }
})();

})();
